import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { envParams } from 'src/app/models/envParams-model';
import { profileAttributes } from 'src/app/models/profile-attribute-model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private isDisplayMainChatArea: string="";
  private storeChatData: Array<any> =[];
  private disableMessage:string = "";
  private islocalStorageEnabled: boolean = false;
  private isBackClicked:boolean = false;
  private isUnreadMessage: boolean = false;
  private isMobileApp: boolean = false;
  userLoggedIn: string = 'false';
  private isAiModuleCalled: boolean = false;
  private storeBackUrl = "";
  private storePageName = ""
  private livechatURL= '';
  private iframeOpen = '';
  private childLoading: boolean = false;
  public trackNavigationStart = false;
  public isActionViewOpen = false;
  private isGptcalled = false;

 
  private profileData:Array<profileAttributes> =[];
  envParams: envParams =  new envParams();
  reverify: boolean = false;
  chatId: string = '';
  hash: string = '';
  hideBack:boolean = false;
  countChar = 0;
  displayFeedback = 0;
  public isMailSent: boolean = false;

  constructor() { }
 
// stores minimize screen display
  changeDisplay(newDisplay: string) {
    this.isDisplayMainChatArea = newDisplay;
  }
  getDisplay(): string {
    return this.isDisplayMainChatArea;
  }
// stores session value////
  changeStoreChatData(newstoreChatData: any) {
    this.storeChatData = newstoreChatData;
  }
  getStoreChatData() {
    return this.storeChatData;
  }
 // Set child loading state
 setChildLoadingState(isLoading: boolean): void {
  this.childLoading = isLoading;
}

// Get child loading state
isChildLoading(): boolean {
  return this.childLoading;
}
  changeDisableMessage(newDisableMessage: string) {
    this.disableMessage = newDisableMessage;
  }
  getDisableMessage() {
    return this.disableMessage;
  }





  getiframeOpen() {
    let iframe = sessionStorage.getItem('iframeOpen');
    return iframe;
   }
   setiframeOpen() {
    sessionStorage.setItem('iframeOpen', 'true');
   }
   removeiframeOpen(){
     sessionStorage.removeItem('iframeOpen');
   }

  changestoreBackUrl(newstoreBackUrl: string) {
    this.storeBackUrl = newstoreBackUrl;
  }
  getstoreBackUrl() {
    return this.storeBackUrl;
  }
  setProfileData(data: Array<profileAttributes>) {
    this.profileData = data;
  }
  getProfileData(){
    return this.profileData;
  }





  // read data from local storage ////
  changeislocalStorageEnabled(newislocalStorageEnabled: boolean) {
    this.islocalStorageEnabled = newislocalStorageEnabled;
  }
  getislocalStorageEnabled(): boolean {
    return this.islocalStorageEnabled;
  }

  // stores call api when back clicked ///
  changeisBackClicked(newisBackClicked: boolean) {
    this.isBackClicked = newisBackClicked;
  }
  getisBackClicked(): boolean {
    return this.isBackClicked;
  }
// stores call  when back clicked ///
changehideBack(newhideBack: boolean) {
  this.hideBack = newhideBack;
}
getishideBack(): boolean {
  return this.hideBack;
}
  // stores unread gif //
  changeisUnreadMessage(newisUnreadMessage: boolean) {
    this.isUnreadMessage = newisUnreadMessage;
  }
  getisUnreadMessage(): boolean {
    return this.isUnreadMessage;
  }

   // stores isMobile App //
   changeisMobileApp(newisMobileApp: boolean) {
    this.isMobileApp = newisMobileApp;
  }
  getisMobileApp(): boolean {
    return this.isMobileApp;
  }

  changeisAiModuleCalled(newisAiModuleCalled: boolean) {
    this.isAiModuleCalled = newisAiModuleCalled;
  }
  getisAiModuleCalled(): boolean {
    return this.isAiModuleCalled;
  }

  changestorePageName(newstorePageName: string) {
    this.storePageName = newstorePageName;
    sessionStorage.setItem('storePageName', this.storePageName);
  }
  getstorePageName(): string {
    let storePageName = this.storePageName? this.storePageName: sessionStorage.getItem('storePageName');
    return storePageName? storePageName : '';
  }

  changeisGptcalled(newisGptcalled: boolean) {
    this.isGptcalled = newisGptcalled;
  }
  getisGptcalled(): boolean {
    return this.isGptcalled;
  }


}
